import { Tabs } from '@/types';

export abstract class LinkHelper {
    public static calculator = '/calc';

    public static ltl: Tabs.Types = 'ltl';
    public static ftl: Tabs.Types = 'ftl';
    public static individual = 'individual';
}
